module.exports = __webpack_public_path__ + "img/1504582518.fb9b3629.jpg";